import { styled } from 'styled-components'

import { useAnimatedIsOpen } from 'peach/hooks'

const Content = styled.div`
  transform: translateY(-5px) scale(0.96);
  transition: 0.2s;
  opacity: 0;
  height: 100%;

  &.is-in {
    transform: translateY(0) scale(1);
    opacity: 1;
  }

  &.is-out {
    transform: translateY(-5px) scale(0.96);
    opacity: 0;
  }
`

const SlidingWindow = ({ children, isOpen }) => {
  const [isMounted, $isOpen] = useAnimatedIsOpen(isOpen, 200)

  return isMounted ? (
    <Content className={$isOpen ? 'is-in' : 'is-out'}>{children}</Content>
  ) : null
}

export default SlidingWindow
